import { render } from "./VueLikedButton.vue?vue&type=template&id=e42127e6&ts=true&lang=pug"
import script from "./VueLikedButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueLikedButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueLikedButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e42127e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e42127e6', __exports__)) {
    api.reload('e42127e6', __exports__)
  }
  
  module.hot.accept("./VueLikedButton.vue?vue&type=template&id=e42127e6&ts=true&lang=pug", () => {
    api.rerender('e42127e6', render)
  })

}


export default __exports__